import { createFileRoute } from '@tanstack/react-router';
import { SystemDetailPage } from '@/pages/organization/systems/SystemDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/systems/$systemId')({
  loader: createEntityBreadcrumbLoader('system', 'systemId'),
  component: RouteComponent
});

function RouteComponent() {
  const { systemId } = Route.useParams();
  return <SystemDetailPage systemId={systemId} />;
}
